<template>
  <div v-if="after10thFeb && ukBooking">
    <h6 v-if="showTfTopup || showExternalTopup" class="ml-2">Cancellation Cover</h6>
    <div v-if="showTfTopup && !showExternalTopup">
      <p class="text-left">
        To ensure the whole value of your trip is covered, please speak to your travel consultant to top up your cancellation cover between {{ cancellationAmounts('tf-ins') }}
      </p>
    </div>
    <div v-else-if="showExternalTopup && !showTfTopup">
      <p class="text-left">
        To ensure the whole value of your trip is covered
        <a href="#" @click.prevent="() => topUpCancellationLink()">Click here</a>
        to top up your cancellation & curtailment cover between
        {{ cancellationAmounts('external') }}
      </p>
    </div>
    <div v-else-if="showTfTopup && showExternalTopup">
      <p class="text-left">
        To ensure the whole value of your trip is covered, please speak to your travel consultant to top up your cancellation cover between {{ cancellationAmounts('both-tf-ins') }}.<br />
        For even further coverage 
        <a href="#" @click.prevent="() => topUpCancellationLink()">Click here</a> to top up between {{ cancellationAmounts('both-external') }}
      </p>
    </div>
  </div>
  
  <div v-else-if="checkShowOldTopupInsurance" class="insurance-cancellation">
    <h6 class="ml-2">Cancellation Cover</h6>
    <p v-if="checkBackpacker" class="text-left">
      <a href="#" @click.prevent="() => topUpCancellationLink()">Click here</a>
      to top up your cancellation & curtailment cover up to a maximum of
      {{ currency }}50,000pp<br />
      <span
        >Brought to you by Trailfinders in association with Top Up My
        Cancellation Cover and underwritten by selected Underwriters at Lloyds.
        Please note Top Up Cancellation Cover is not arranged or sold by
        Trailfinders.</span
      >
    </p>
    <p v-else class="text-left">
      <a href="#" @click.prevent="() => topUpCancellationLink()">Click here</a>
      to top up your cancellation & curtailment cover between
      {{ currency }}5,000pp - {{ currency }}50,000pp<br />
      <span
        >Brought to you by Trailfinders in association with Top Up My
        Cancellation Cover and underwritten by selected Underwriters at Lloyds.
        Please note Top Up Cancellation Cover is not arranged or sold by
        Trailfinders.</span
      >
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getSite } from "@/lib/utilities";
import dayjs, { parseWithWeekday } from '@/lib/dayjs';
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dropdown: true,
      backpacker: false,
    };
  },
  computed: {
    ...mapGetters({
      accountInfo: "booking/getAccount",
      bookno: "booking/getBookingNumber",
      dest: "booking/getDestination",
      itinerary: "booking/getItinerary",
      booking: "booking/getBooking",
    }),
    checkShowOldTopupInsurance() {
      if (
        this.accountInfo.perPersonCost >= 5000 &&
        this.bookno.charAt(0).toUpperCase() !== "R"
      ) {
        return true;
      } else if (
        this.dest === "INS" &&
        this.bookno.charAt(0).toUpperCase() !== "R"
      ) {
        return true;
      } else if (
        this.itinerary &&
        this.itinerary.insuranceItem &&
        this.itinerary.insuranceItem.insurancefor
      ) {
        return true;
      }
      return false;
    },
    checkBackpacker() {
      if (
        this.itinerary &&
        this.itinerary.insuranceItem &&
        this.itinerary.insuranceItem.insurancefor &&
        this.itinerary.insuranceItem.insurancefor.includes("backpacker") &&
        this.accountInfo.perPersonCost >= 2000
      ) {
        return true;
      }
      return false;
    },
    currency() {
      let currency;
      getSite() === "com" ? (currency = "£") : (currency = "€");
      return currency;
    },
    after10thFeb() {
      // 10th feb 2026 is when the insurance top up logic is changing. Prior to this, all top up was done externally. afterwards, this can be done through TF
      if (this.itinerary && (this.itinerary.insuranceItem || this.itinerary.insuranceOptionalItem) && this.booking && this.booking.booking_information && this.booking.booking_information.vtdate_created) {
        const tenthFeb26 = dayjs('2026/02/10')
        const bookingCreatedDate = parseWithWeekday(this.booking.booking_information.vtdate_created, 'ddd DD MMM YYYY')
        if (bookingCreatedDate.isValid() && bookingCreatedDate.isSameOrAfter(tenthFeb26)) {
          // booking created on/ after the 10th feb 26, no need for further checks.
          return true
        } else if (this.itinerary.insuranceItem.bookdate) {
          // check whether the insurance was taken out on/ after 10th feb 26 (as this can be added at a later date)
          const insuranceBookedDate = parseWithWeekday(this.itinerary.insuranceItem.bookdate, 'ddd DD MMM YYYY')
          if (insuranceBookedDate.isValid() && insuranceBookedDate.isSameOrAfter(tenthFeb26)) {
            return true
          }
        }
      }
      return false
    },
    ukBooking(){
      return this.bookno.charAt(0).toUpperCase() !== "R"
    },
    insuranceMessages() {
      // returns 1 of 4 string values: 'none', 'tf', 'external' or 'both'.
      let topupAmountPp = 0
      if (this.itinerary && this.itinerary.insuranceTopupAmountPerPerson) {
        topupAmountPp = this.itinerary.insuranceTopupAmountPerPerson
      }
      const totalCoveredPp = 7000 + topupAmountPp
      let insMessageToShow = ''
      if (this.dest === 'INS') insMessageToShow = 'both' // insurance only booking. Show both topup messages
      else if (this.accountInfo.perPersonCost <= 7000) insMessageToShow = 'none' // no messages
      else if (this.accountInfo.perPersonCost > 7000 && this.accountInfo.perPersonCost <= 20000) {
        // additional checks needed to see if top up cover will cover the total balance.
        // e.g. if perPersonCost is £10,000, and the client has purchased £3000 topup cover (on top of the standard £7000 cover), then they do not need any additional top up cover. But if they have only purchased 2000 topup per person, there is an overlay of £1000pp.
        insMessageToShow = this.accountInfo.perPersonCost <= totalCoveredPp ? 'none' : 'tf'
      } 
      else {
        // over £20k per person booking cost
        // if the clients total coverage is less than the max of £20k, then we want to show both tf and external text.
        // if they have maxed out their 20k pp coverage through tf, then only show external message
        insMessageToShow = totalCoveredPp < 20000 ? 'both' : 'external'
      }
      return insMessageToShow
    },
    showTfTopup() {
      // whether to show the text for clients to contact us & top up through TF
      return this.insuranceMessages === 'tf' || this.insuranceMessages === 'both'
    },
    showExternalTopup() {
      return this.insuranceMessages === 'external' || this.insuranceMessages === 'both'
    },
  },
  methods: {
    topUpCancellationLink() {
      window.open(
        "https://quote.topupmycancellationcover.com?tracking=ebadc869-e812-4be2-a177-7754e7fe9830&campaignCode=TRAILFINDERS",
        "_blank"
      );
    },
    cancellationAmounts(type) {
      // type will be either 'tf-ins' or 'external'
      const isBackpacker =
        this.itinerary &&
        this.itinerary.insuranceItem &&
        this.itinerary.insuranceItem.insurancefor &&
        this.itinerary.insuranceItem.insurancefor.includes('backpacker')
      let coverAmounts = ''
      if (type.includes('tf-ins')) {
        // topup cover with TF
        coverAmounts = isBackpacker
          ? `${this.currency}2,000pp - ${this.currency}5,000pp`
          : `${this.currency}7,000pp - ${this.currency}20,000pp`
      } else {
        // external cover
        coverAmounts = isBackpacker
          ? `${this.currency}5,000pp - ${this.currency}50,000pp`
          : `${this.currency}20,000pp - ${this.currency}70,000pp`
      }
      return coverAmounts
    },
  },
};
</script>

<style lang="scss">
@import "../styles";
</style>
